import { render, staticRenderFns } from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=template&id=44780ec4&scoped=true&"
import script from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=style&index=0&id=44780ec4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44780ec4",
  null
  
)

export default component.exports